import Loading from '@components/Loading';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

import useSignInWithApple from './hooks/useSignInWithApple';

interface Params {
    code: string;
}

declare module '@stackflow/config' {
    interface Register {
        SignInWithAppleActivity: Params;
    }
}

const SignInWithAppleActivity: ActivityComponentType<'SignInWithAppleActivity'> = ({ params }) => {
    const { code } = params;
    useSignInWithApple(code);
    return (
        <AppScreen>
            <Loading/>
        </AppScreen>
    );
};

export default SignInWithAppleActivity;
